import { render, staticRenderFns } from "./Addservers.vue?vue&type=template&id=12092ed0&"
import script from "./Addservers.vue?vue&type=script&lang=js&"
export * from "./Addservers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports